import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { useToast } from '@chakra-ui/react';
import { PAGE_SIZE } from '~/constants';
import { Pagination } from '~/types';
import { Dashboard } from '~/types/dashboard';
import {
  getDashboardById,
  getDashboards,
  getDashboardsAvailable,
} from '~/services/Dashboard';
import { useFeatureFlags } from '~/contexts/FeatureFlagsContext/FeatureFlagsContext';

export function useDashboards(
  page: number,
  pageSize: number = PAGE_SIZE,
  options: UseQueryOptions<Pagination<Dashboard>, unknown> = {},
): UseQueryResult<Pagination<Dashboard>, unknown> {
  return useQuery<Pagination<Dashboard>, unknown>(
    ['dashboards', page, pageSize],
    () => getDashboards(page, pageSize),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}

export function useDashboardsAvailable(
  options: UseQueryOptions<Dashboard[]> = {},
): UseQueryResult<Dashboard[]> {
  const toast = useToast();
  const features = useFeatureFlags();
  return useQuery<Dashboard[]>(
    ['dashboardsAvailable'],
    () => getDashboardsAvailable(),
    {
      staleTime: 1000 * 60 * 5, // 5 minutes
      ...options,
      onError: () => {
        toast({
          title: 'Erro',
          description: 'Erro ao buscar relatórios, tente novamente',
          status: 'error',
          duration: 3000,
          isClosable: true,
          position: 'top-right',
        });
      },
      enabled: features.dashboardsPowerBiEmbeddedEnabled,
    },
  );
}

export function useDashboardById(
  id: string,
  options: UseQueryOptions<Dashboard, unknown> = {},
): UseQueryResult<Dashboard, unknown> {
  const toast = useToast();
  return useQuery<Dashboard, unknown>(
    ['dashboard', id],
    () => getDashboardById(id),
    {
      staleTime: 1000 * 60 * 10, // 10 minutes
      ...options,
    },
  );
}
